import { authGet } from "@api";
import { UserInvite } from "@types";

export const fetchUserInvites = (): Promise<UserInvite[]> => {
  return authGet<{ user_invites: UserInvite[] }>(
    `/api/agent/user/user_invites`
  ).then((result) => result.user_invites);
};
